<template>
  <v-app>
    <v-navigation-drawer id="appMenu" class="accent" width=260 v-if="isLoggedIn" persistent :mini-variant="miniVariant" :clipped="clipped" v-model="drawer" enable-resize-watcher permanent fixed app>
      <v-list>
        <v-list-tile>
          <v-list-tile-action style="min-width: 40px">
            <v-avatar size="25px">
              <img src="@/assets/YakshofLogo.png" :alt="title"/>
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content><v-list-tile-title class="white--text title" v-text="title"></v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/home', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('home')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/home')" slot="activator">fas fa-home</v-icon>
                <span>Home</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('home')" v-else>
              <v-icon :class="getIconColor('/home')">fas fa-home</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/home', query: $route.query })"><v-list-tile-title><v-btn :ripple='false' :href="getMenuButtonQuery('home')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/home')" flat>Home</v-btn></v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/tweets', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('tweets')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/tweets')" slot="activator">fab fa-twitter</v-icon>
                <span>Tweets</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('tweets')" v-else>
              <v-icon :class="getIconColor('/tweets')">fab fa-twitter</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/tweets', query: $route.query })"><v-list-tile-title><v-btn :ripple='false' :href="getMenuButtonQuery('tweets')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/tweets')" flat>Tweets</v-btn></v-list-tile-title></v-list-tile-content>
        </v-list-tile>

        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/hashtags', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('hashtags')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/hashtags')" slot="activator">fas fa-hashtag</v-icon>
                <span>Hashtags</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('hashtags')" v-else>
              <v-icon :class="getIconColor('/hashtags')">fas fa-hashtag</v-icon>
            </v-btn>
          </v-list-tile-action>
            <v-list-tile-content @click="$router.push({ path: '/hashtags', query: $route.query })">
              <v-list-tile-title>
                <v-btn :ripple='false' :href="getMenuButtonQuery('hashtags')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/hashtags')" flat>
                  Hashtags
                </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/users', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('users')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/users')" slot="activator">fas fa-users</v-icon>
                <span>Users</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('users')" v-else>
              <v-icon :class="getIconColor('/users')">fas fa-users</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/users', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('users')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/users')" flat>
                Users
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/articles', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('articles')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/articles')" slot="activator">fa-newspaper</v-icon>
                <span>Articles</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('articles')" v-else>
              <v-icon :class="getIconColor('/articles')">fa-newspaper</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/articles', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('articles')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/articles')" flat>
                Articles
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/sources', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('sources')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/sources')" slot="activator">fas fa-desktop</v-icon>
                <span>Sources</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('sources')" v-else>
              <v-icon :class="getIconColor('/sources')">fas fa-desktop</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/sources', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('sources')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/sources')" flat>
                Sources
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/stories', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('stories')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/stories')" slot="activator">fas fa-comments</v-icon>
                <span>Stories</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('stories')" v-else>
              <v-icon :class="getIconColor('/stories')">fas fa-comments</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/stories', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('stories')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/stories')" flat>
                Stories
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/sentiment', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('sentiment')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/sentiment')" slot="activator">fas fa-heartbeat</v-icon>
                <span>Sentiment</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('sentiment')" v-else>
              <v-icon :class="getIconColor('/sentiment')">fas fa-heartbeat</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/sentiment', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('sentiment')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/sentiment')" flat>
                Sentiment
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/entities', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('entities')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/entities')" slot="activator">fas fa-tags</v-icon>
                <span>Entities</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('entities')" v-else>
              <v-icon :class="getIconColor('/entities')">fas fa-tags</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/entities', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('entities')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/entities')" flat>
                Entities
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile style="cursor: pointer;">
          <v-list-tile-action @click="$router.push({ path: '/backtracker', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('backtracker')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/backtracker')" slot="activator">fas fa-backward</v-icon>
                <span>Backtracker</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('backtracker')" v-else>
              <v-icon :class="getIconColor('/backtracker')">fas fa-backward</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/backtracker', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('backtracker')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/backtracker')" flat>
                Backtracker
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile style="cursor: pointer;" v-if="useSocketIO === true">
          <v-list-tile-action @click="$router.push({ path: '/live', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('live')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/live')" slot="activator">fas fa-microphone</v-icon>
                <span>Live View</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('live')" v-else>
              <v-icon :class="getIconColor('/live')">fas fa-microphone</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/live', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('live')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/live')" flat>
                Live View
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile style="cursor: pointer;" v-if="useSocketIO === true">
          <v-list-tile-action @click="$router.push({ path: '/report', query: $route.query })" :style="miniVariant? '' : 'min-width: auto; margin-right:5px'">
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('report')" v-if="miniVariant">
              <v-tooltip right>
                <v-icon :class="getIconColor('/report')" slot="activator">fas fa-file-pdf</v-icon>
                <span>Live View</span>
              </v-tooltip>
            </v-btn>
            <v-btn :ripple='false' icon :href="getMenuButtonQuery('report')" v-else>
              <v-icon :class="getIconColor('/report')">fas fa-file-pdf</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content @click="$router.push({ path: '/report', query: $route.query })">
            <v-list-tile-title>
              <v-btn :ripple='false' :href="getMenuButtonQuery('report')" class="pa-0 ma-0" style="text-align: left" :class="getIconColor('/report')" flat>
                Generate Report
              </v-btn>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer width=400 v-model="filtersDrawer" v-if='isLoggedIn' persistent :permanent="filtersDrawer" app temporary fixed right disable-route-watcher id="appFiltersForm">
      <v-expansion-panel :value='0'>
        <v-expansion-panel-content class="secondary">
          <div slot="header">Locality Filters</div>
          <v-container class="white">
            <v-layout row wrap>
              <v-flex xs12>
                <v-form autocomplete="off">
                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-autocomplete slot="activator" deletable-chips multiple chips hide-no-data :items="countriesArray" v-model="countryId" label="Country:" :loading="countriesLoading" :search-input.sync="searchCountries" item-text="name" item-value="id" hint="">
                        <template slot="countriesArray" slot-scope="data">
                          <v-chip :selected="data.selectedCountries" :key="JSON.stringify(data.item)" class="chip--select-multi" @input="data.parent.selectItem(data.item)">{{ data.item.name }}</v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                          <template v-if="typeof data.item !== 'object'"><v-list-tile-content v-text="data.item"></v-list-tile-content></template>
                          <template v-else>
                            <v-list-tile-content><v-list-tile-title v-html="data.item.name"></v-list-tile-title></v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <span>start typing to search</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-autocomplete slot="activator" deletable-chips multiple hide-no-data chips :items="statesArray" v-model="stateId" label="State:" :loading="statesLoading" :search-input.sync="searchStates" item-text="name" item-value="id" hint="">
                        <template slot="statesArray" slot-scope="data">
                          <v-chip :selected="data.selectedStates" :key="JSON.stringify(data.item)" close class="chip--select-multi" @input="data.parent.selectItem(data.item)">
                            {{ data.item.name + ' ' + (data.item.country ? '(' + data.item.country.name + ')' : '') }}
                          </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                          <template v-if="typeof data.item !== 'object'"><v-list-tile-content v-text="data.item"></v-list-tile-content></template>
                          <template v-else>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ data.item.name + ' ' + (data.item.country ? '(' + data.item.country.name + ')' : '') }}</v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <span>start typing to search</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-autocomplete slot="activator" deletable-chips multiple hide-no-data chips :items="citiesArray" v-model="cityId" label="City:" :loading="citiesLoading" :search-input.sync="searchCities" item-text="name" item-value="id" hint="">
                        <template slot="citiesArray" slot-scope="data">
                          <v-chip :selected="data.selectedCities" :key="JSON.stringify(data.item)" close class="chip--select-multi" @input="data.parent.selectItem(data.item)">
                            {{ data.item.name + ' ' + (data.item.country && data.item.state ? '(' + data.item.state.code + ', ' + data.item.country.name + ')' : '') + ' ' + (data.item.country && !data.item.state ? '(' + data.item.country.name + ')' : '')}}
                          </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                          <template v-if="typeof data.item !== 'object'"><v-list-tile-content v-text="data.item"></v-list-tile-content></template>
                          <template v-else>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ data.item.name + ' ' + (data.item.country && data.item.state ? '(' + data.item.state.code + ', ' + data.item.country.name + ')' : '') + ' ' + (data.item.country && !data.item.state ? '(' + data.item.country.name + ')' : '')}}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <span>start typing to search</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-autocomplete slot="activator" deletable-chips multiple chips hide-no-data :items="languagesArray" v-model="languageId" label="Language:" :loading="languagesLoading" :search-input.sync="searchLanguages" item-text="name" item-value="id" hint="">
                        <template slot="languagesArray" slot-scope="data">
                          <v-chip :selected="data.selectedLanguages" :key="JSON.stringify(data.item)" class="chip--select-multi" @input="data.parent.selectItem(data.item)">{{ data.item.name }}</v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                          <template v-if="typeof data.item !== 'object'"><v-list-tile-content v-text="data.item"></v-list-tile-content></template>
                          <template v-else>
                            <v-list-tile-content><v-list-tile-title v-html="data.item.name"></v-list-tile-title></v-list-tile-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <span>start typing to search</span>
                    </v-tooltip>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content class="secondary">
          <div slot="header">General Filters</div>
          <v-container class="white">
            <v-layout row wrap>
              <v-flex xs12>
                <v-form autocomplete="off">
                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-text-field v-on:keyup.enter='addTextFilter' slot="activator" append-icon="add" @click:append='addTextFilter' v-model="tempText" label="Text:"></v-text-field>
                      <span>click + button after typing each keyword</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex sm12>
                    <v-chip close v-for="item in text" :key='item' @input="removeTextFilter(item)">{{item}}</v-chip>
                  </v-flex>

                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-text-field v-on:keyup.enter='addExcludeTermFilter' slot="activator" append-icon="add" @click:append='addExcludeTermFilter' v-model="tempExcludeTerm" label="Exclude Term:"></v-text-field>
                      <span>click + button after typing each keyword</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex sm12>
                    <v-chip close v-for="item in excludeTerm" :key='item' @input="removeExcludeTermFilter(item)">{{item}}</v-chip>
                  </v-flex>

                  <v-flex sm12>
                    <v-select v-model="sentiment" :items="[{value: -2, name: 'Very Negative'}, {value: -1, name: 'Negative'}, {value: 0, name: 'Neutral'}, {value: 1, name: 'Positive'}, {value: 2, name: 'Very Positive'}]" attach chips label="Sentiment:" multiple item-text="name" item-value="value"></v-select>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content class="secondary">
          <div slot="header">Twitter Filters</div>
          <v-container class="white">
            <v-layout row wrap>
              <v-flex xs12>
                <v-form autocomplete="off">
                  <v-flex sm12>
                    <v-select v-model="tweetType" :items="[{value: 'TWEET', name: 'Regular Tweets'}, {value: 'RETWEET', name: 'Retweets'}, {value: 'QUOTE_TWEET', name: 'Quote Tweets'}, {value: 'REPLY_TWEET', name: 'Reply Tweets'}]" attach chips label="Tweet Type:" multiple item-text="name" item-value="value"></v-select>
                  </v-flex>
                  
                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-text-field v-on:keyup.enter='addScreenNameFilter' slot="activator" append-icon="add" @click:append='addScreenNameFilter' v-model="tempScreenName" label="Screen Name:" style="line-height: 50px;"></v-text-field>
                      <span>click + button after typing each keyword</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex sm12>
                    <v-chip close v-for="item in screenName" :key='item' @input="removeScreenNameFilter(item)">{{item}}</v-chip>
                  </v-flex>

                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-text-field v-on:keyup.enter='addHashtagFilter' slot="activator" append-icon="add" @click:append='addHashtagFilter' v-model="tempHashtag" label="Hashtag:"></v-text-field>
                      <span>click + button after typing each hashtag</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex sm12>
                    <v-chip close v-for="item in hashtag" :key='item' @input="removeHashtagFilter(item)">{{item}}</v-chip>
                  </v-flex>
                  
                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-text-field v-on:keyup.enter='addEmojiFilter' slot="activator" prepend-inner-icon="mood" append-icon="add" @click:append='addEmojiFilter' @click:prepend-inner='showEmojiKeyboard = !showEmojiKeyboard' v-model="tempEmoji" label="Emoji:"></v-text-field>
                      <span>click + to add an emoji</span>
                    </v-tooltip>
                    <picker :style="{ width: '340px' }" :i18n="{ search: '', categories: { search: '', recent: '' } }" @select="addEmojiFilterFromEmojiKeyboard" v-if="showEmojiKeyboard === true"/>
                  </v-flex>
                  <v-flex sm12>
                    <v-chip close v-for="item in emoji" :key='item' @input="removeEmojiFilter(item)">{{item}}</v-chip>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content class="secondary">
          <div slot="header">News/Articles Filters</div>
          <v-container class="white">
            <v-layout row wrap>
              <v-flex xs12>
                <v-form autocomplete="off">
                  <v-flex sm12>
                    <v-tooltip bottom>
                      <v-text-field v-on:keyup.enter='addDomainFilter' slot="activator" append-icon="add" @click:append='addDomainFilter' v-model="tempDomain" label="Domain:"></v-text-field>
                      <span>click + button after typing each domain (use * for wildcard)</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex sm12>
                    <v-chip close v-for="item in domain" :key='item' @input="removeDomainFilter(item)">{{item}}</v-chip>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content class="secondary">
          <div slot="header">Filter Toggles</div>
          <v-container class="white">
            <v-layout row wrap>
              <v-flex xs12><v-switch color="accent" label="Show Only Detected Tweets/Users" v-model="isDetected"></v-switch></v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content class="secondary">
          <div slot="header">UI Toggles</div>
          <v-container class="white">
            <v-layout row wrap>
              <v-flex xs12><v-switch color="accent" label="Show Filter Chips" v-model="filtersChipsToggle"></v-switch></v-flex>
              <v-flex xs12><v-switch color="accent" label="Show Latest Listings" v-model="latestListingsToggle"></v-switch></v-flex>
              <v-flex xs12><v-switch color="accent" label="Show Top Listings" v-model="topListingsToggle"></v-switch></v-flex>
              <v-flex xs12><v-switch color="accent" label="Show Twitter Counters" v-model="showLatestCountersForTweetsToggle"></v-switch></v-flex>
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
  
      <v-container grid-list-sm text-sx-center>
        <v-layout row wrap>
          <v-flex xs12>
            <form autocomplete="off">
              <v-btn @click.stop="filtersDrawer = false; dirty = filtersDrawer" class="accent">
                Submit
              </v-btn>
              
              <v-btn @click.stop="resetFilters(); filtersDrawer = false; dirty = filtersDrawer" class="accent">
                Clear
              </v-btn>
            </form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    
    <v-toolbar app :clipped-left="clipped"  class="elevation-0" color="grey lighten-2" v-if="isLoggedIn">
      <v-btn icon @click.stop="miniVariant = !miniVariant" v-if="isLoggedIn">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div v-if="isLoggedIn" class="accent px-2 elevation-2 sm3" dark id="projectsSelector" :style="resizeProjectsDropDown()">
        <v-form autocomplete="off">
          <v-autocomplete dark attach class="mr-2" hide-no-data :items="this.currentUser.projects" v-model="projectUuid" item-text="name" item-value="uuid" hint="">
          </v-autocomplete>
        </v-form>
      </div>
      <v-menu attach offset-y left v-if="isLoggedIn" :close-on-content-click="false">
        <v-btn slot="activator" color="accent" dark prepend-icon="event" v-html="getDateRangeData()"></v-btn>
        <DateRange  
          :options="dateRangeOptions" 
          :filters="getFilters" 
          @input="onDateRangeChange" 
          style="background: white !important; padding-top: 35px !important; padding-bottom: 35px !important;">
        </DateRange>
      </v-menu>
      <v-menu offset-y v-if="isLoggedIn">
        <v-btn slot="activator" color="accent" dark @click.stop="filtersDrawer = !filtersDrawer; dirty = filtersDrawer" >
          Filters
        </v-btn>
      </v-menu>
      <v-menu bottom left offset-y>
        <div id="userChip" class="text-xs-center pointerClass" slot="activator"><v-chip class="pointerClass hover"><v-icon>account_box</v-icon><span style="font-size: 16px">{{currentUser.firstName}} {{currentUser.lastName}}</span></v-chip></div>
        <v-list class="pa-0">
          <v-list-tile @click="$router.push({ path: '/login', query: $route.query }); $store.dispatch('auth/logout')">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <notifier></notifier>
  </v-app>
</template>

<style scoped>
.input-date {
  width: 400px;
}
.pointerClass{
  cursor: pointer;
}
</style>

<style>
  #projectsSelector{
    font-size: 14px !important;
    min-width: 150px !important
  }
  #projectsSelector .v-list__tile{
    font-size: 14px !important;
  }
  #projectsSelector .v-input{
    height: 36px;
    padding: 0;
    margin: 0 !important;
  }
  #projectsSelector input{
    margin-top: 0;
    font-size: 14px;
    width: auto;
    text-transform: uppercase !important;
    padding-bottom: 0 !important;
  }
  #appFiltersForm .v-text-field input{
    max-height: 42px;
    height: 42px;
  }
  #appMenu a:before{
    display: none;
  }
  #appMenu .v-list__tile__title .v-btn__content{
    text-align: left;
    -webkit-justify-content: left;
    justify-content: left;
    margin-left: 15px
  }
  #userChip .v-chip:hover{
    border-color: rgba(0,0,0,.13);
    -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }
</style>

<script>
import underscore from 'underscore'
import DateRange from './components/DateRange'
import Notifier from './components/Notifier'
import axios from 'axios'
import { Picker } from 'emoji-mart-vue'
import { format, subDays } from 'date-fns'
import { mapGetters, mapMutations } from 'vuex'
import { formatDate } from '@/helpers/formatters'
import config from '@/helpers/config'

export default {
  data () {
    return {
      filtersDrawer: false,
      clipped: false,
      drawer: true,
      fixed: false,
      miniVariant: true,
      showEmojiKeyboard: false,
      languagesLoading: false,
      searchLanguages: null,
      countriesLoading: false,
      searchCountries: null,
      statesLoading: false,
      searchStates: null,
      citiesLoading: false,
      searchCities: null,
      title: 'Yakshof Data Slicer',
      tempScreenName: null,
      tempText: null,
      tempExcludeTerm: null,
      tempHashtag: null,
      tempEmoji: null,
      tempDomain: null,
      dateRangeOptions: {
        startDate: this.$route.query.fromDate ? this.$route.query.fromDate : this.$store.getters['filters/getFromDate'],
        endDate: this.$route.query.toDate ? this.$route.query.toDate : this.$store.getters['filters/getToDate'],
        format: config.defaultDateFormat,
        presets: [
          {
            label: 'Today',
            range: [
              format(new Date(), config.defaultDateFormat),
              format(new Date(), config.defaultDateFormat)
            ]
          },
          {
            label: 'Yesterday',
            range: [
              format(subDays(new Date(), 1), config.defaultDateFormat),
              format(subDays(new Date(), 1), config.defaultDateFormat)
            ]
          },
          {
            label: 'Last 7 Days',
            range: [
              format(subDays(new Date(), 7), config.defaultDateFormat),
              format(subDays(new Date(), 0), config.defaultDateFormat)
            ]
          },
          {
            label: 'Last 30 Days',
            range: [
              format(subDays(new Date(), 30), config.defaultDateFormat),
              format(subDays(new Date(), 0), config.defaultDateFormat)
            ]
          },
          {
            label: 'Last 60 Days',
            range: [
              format(subDays(new Date(), 60), config.defaultDateFormat),
              format(subDays(new Date(), 0), config.defaultDateFormat)
            ]
          },
          {
            label: 'Last 90 Days',
            range: [
              format(subDays(new Date(), 90), config.defaultDateFormat),
              format(subDays(new Date(), 0), config.defaultDateFormat)
            ]
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('filters', ['getFilters', 'getQuery', 'getCustomQuery', 'getQueryInternal']),
    ...mapGetters('toggles', ['getLatestListings', 'getTopListings', 'getFiltersChips', 'getShowLatestCountersForTweets']),
    ...mapGetters({
      countries: 'getCountries',
      selectedCountries: 'getSelectedCountries',
      states: 'getStates',
      selectedStates: 'getSelectedStates',
      cities: 'getCities',
      selectedCities: 'getSelectedCities',
      getCountryById: 'getCountryById',
      getStateById: 'getStateById',
      getCityById: 'getCityById',
      languages: 'getLanguages',
      selectedLanguages: 'getSelectedLanguages',
      getLanguageById: 'getLanguageById'
    }),
    useSocketIO: function () {
      return config.useSocketIO
    },
    latestListingsToggle: {
      get () {
        return this.getLatestListings
      },
      set (value) {
        this.setLatestListings(value)
      }
    },
    topListingsToggle: {
      get () {
        return this.getTopListings
      },
      set (value) {
        this.setTopListings(value)
      }
    },
    filtersChipsToggle: {
      get () {
        return this.getFiltersChips
      },
      set (value) {
        this.setFiltersChips(value)
      }
    },
    showLatestCountersForTweetsToggle: {
      get () {
        return this.getShowLatestCountersForTweets
      },
      set (value) {
        this.setShowLatestCountersForTweets(value)
      }
    },
    countriesArray: function () {
      return this.mergedArray(this.countries, this.selectedCountries, 'id')
    },
    statesArray: function () {
      return this.mergedArray(this.states, this.selectedStates, 'id')
    },
    citiesArray: function () {
      return this.mergedArray(this.cities, this.selectedCities, 'id')
    },
    languagesArray: function () {
      return this.mergedArray(this.languages, this.selectedLanguages, 'id')
    },
    dirty: {
      get () {
        return this.getDirty
      },
      set (value) {
        this.setDirty(value)
      }
    },
    projectUuid: {
      get () {
        return this.getFilters.projectUuid
      },
      set (value) {
        this.setCustomFilters({projectUuid: value})
        this.resetCustomFilters({fromDate: true, toDate: true})
      }
    },
    fromDate: {
      get () {
        return this.getFilters.fromDate
      },
      set (value) {
        this.setCustomFilters({fromDate: value})
      }
    },
    toDate: {
      get () {
        return this.getFilters.toDate
      },
      set (value) {
        this.setCustomFilters({toDate: value})
      }
    },
    isDetected: {
      get () {
        return this.getFilters.isDetected
      },
      set (value) {
        this.setCustomFilters({isDetected: value})
      }
    },
    countryId: {
      get () {
        return this.getFilters.countryId
      },
      set (value) {
        var valuesArray = Array.isArray(value) ? value : [value]
        var countriesArray = []
        for (var v = 0; v < valuesArray.length; v++) {
          var country = this.selectedCountries.find(item => { return Number(item.id) === Number(valuesArray[v]) })
          if (country) {
            countriesArray.push(country)
          } else {
            countriesArray.push(this.getCountryById(valuesArray[v]))
          }
        }
        this.$store.commit('setSelectedCountries', countriesArray)
        this.setCustomFilters({countryId: value})
      }
    },
    stateId: {
      get () {
        return this.getFilters.stateId
      },
      set (value) {
        var valuesArray = Array.isArray(value) ? value : [value]
        var statesArray = []
        for (var v = 0; v < valuesArray.length; v++) {
          var state = this.selectedStates.find(item => { return Number(item.id) === Number(valuesArray[v]) })
          if (state) {
            statesArray.push(state)
          } else {
            statesArray.push(this.getStateById(valuesArray[v]))
          }
        }
        this.$store.commit('setSelectedStates', statesArray)
        this.setCustomFilters({stateId: value})
      }
    },
    cityId: {
      get () {
        return this.getFilters.cityId
      },
      set (value) {
        var valuesArray = Array.isArray(value) ? value : [value]
        var citiesArray = []
        for (var v = 0; v < valuesArray.length; v++) {
          var city = this.selectedCities.find(item => { return Number(item.id) === Number(valuesArray[v]) })
          if (city) {
            citiesArray.push(city)
          } else {
            citiesArray.push(this.getCityById(valuesArray[v]))
          }
        }
        this.$store.commit('setSelectedCities', citiesArray)
        this.setCustomFilters({cityId: value})
      }
    },
    tweetType: {
      get () {
        return this.getFilters.tweetType
      },
      set (value) {
        this.setCustomFilters({tweetType: value})
      }
    },
    sentiment: {
      get () {
        return this.getFilters.sentiment
      },
      set (value) {
        this.setCustomFilters({sentiment: value})
      }
    },
    screenName: {
      get () {
        return this.getFilters.screenName
      },
      set (value) {
        this.setCustomFilters({screenName: value})
      }
    },
    text: {
      get () {
        return this.getFilters.text
      },
      set (value) {
        this.setCustomFilters({text: value})
      }
    },
    excludeTerm: {
      get () {
        return this.getFilters.excludeTerm
      },
      set (value) {
        this.setCustomFilters({excludeTerm: value})
      }
    },
    hashtag: {
      get () {
        return this.getFilters.hashtag
      },
      set (value) {
        this.setCustomFilters({hashtag: value})
      }
    },
    emoji: {
      get () {
        return this.getFilters.emoji
      },
      set (value) {
        this.setCustomFilters({emoji: value})
      }
    },
    domain: {
      get () {
        return this.getFilters.domain
      },
      set (value) {
        this.setCustomFilters({domain: value})
      }
    },
    languageId: {
      get () {
        return this.getFilters.languageId
      },
      set (value) {
        var valuesArray = Array.isArray(value) ? value : [value]
        var languagesArray = []
        for (var v = 0; v < valuesArray.length; v++) {
          var language = this.selectedLanguages.find(item => { return Number(item.id) === Number(valuesArray[v]) })
          if (language) {
            languagesArray.push(language)
          } else {
            languagesArray.push(this.getLanguageById(valuesArray[v]))
          }
        }
        this.$store.commit('setSelectedLanguages', languagesArray)
        this.setCustomFilters({languageId: value})
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setAllFilters', 'setCustomFilters', 'resetAllFilters', 'resetCustomFilters', 'setDirty', 'getDirty']),
    ...mapMutations('toggles', ['setLatestListings', 'setTopListings', 'setFiltersChips', 'setShowLatestCountersForTweets']),
    resetFilters: function () {
      this.resetAllFilters()
      this.$store.commit('setSelectedCountries', [])
      this.$store.commit('setSelectedStates', [])
      this.$store.commit('setSelectedCities', [])
      this.$store.commit('setSelectedLanguages', [])
    },
    getIconColor: function (path) {
      if (this.$route.path === path) {
        return 'primary--text'
      } else {
        return 'white--text'
      }
    },
    resizeProjectsDropDown: function () {
      var projectsDropDown = document.getElementById('projectsSelector')
      if (projectsDropDown) {
        var longestName = ''
        for (var p = 0; p < this.currentUser.projects.length; p++) {
          longestName = longestName.length > this.currentUser.projects[p].name.length ? longestName : this.currentUser.projects[p].name
        }
        var newElement = document.createElement('div')
        newElement.style.visibility = 'hidden'
        newElement.style.textTransform = 'uppercase'
        newElement.style.position = 'absolute'
        projectsDropDown.appendChild(newElement)
        newElement.innerHTML = longestName
        var elementWidth = newElement.offsetWidth
        newElement.remove()
        return 'width: ' + (elementWidth + 90) + 'px !important'
      }
    },
    getDateRangeData: function () {
      return formatDate(new Date(this.fromDate)) + ' - ' + formatDate(new Date(this.toDate))
    },
    getMenuButtonQuery: function (path) {
      var query = this.getQueryInternal({})
      return '#/' + path + query
    },
    mergedArray: function (a, b, p) {
      return a.filter(aa => !b.find(bb => aa[p] === bb[p])).concat(b)
    },
    onDateRangeChange: function (range) {
      if (this.fromDate === format(range[0], config.defaultDateFormat) && this.toDate === format(range[1], config.defaultDateFormat)) {
        return
      }

      if (this.fromDate !== format(range[0], config.defaultDateFormat)) {
        this.fromDate = format(range[0], config.defaultDateFormat)
      }

      if (this.toDate !== format(range[1], config.defaultDateFormat)) {
        this.toDate = format(range[1], config.defaultDateFormat)
      }
      this.resetCustomFilters({fromTime: true, toTime: true})
    },
    removeScreenNameFilter: function (val) {
      let temp = this.screenName.slice()
      temp = temp.filter(v => v !== val)
      this.screenName = temp
    },
    addScreenNameFilter: function () {
      if (this.tempScreenName && !this.screenName.includes(this.tempScreenName)) {
        let temp = [].slice.call(this.screenName)
        temp.push(this.tempScreenName)
        this.screenName = temp
        this.tempScreenName = null
      }
    },
    removeTextFilter: function (val) {
      let temp = this.text.slice()
      temp = temp.filter(v => v !== val)
      this.text = temp
    },
    addTextFilter: function () {
      if (this.tempText && !this.text.includes(this.tempText)) {
        let temp = [].slice.call(this.text)
        temp.push(this.tempText)
        this.text = temp
        this.tempText = null
      }
    },
    removeExcludeTermFilter: function (val) {
      let temp = this.excludeTerm.slice()
      temp = temp.filter(v => v !== val)
      this.excludeTerm = temp
    },
    addExcludeTermFilter: function () {
      if (this.tempExcludeTerm && !this.excludeTerm.includes(this.tempExcludeTerm)) {
        let temp = [].slice.call(this.excludeTerm)
        temp.push(this.tempExcludeTerm)
        this.excludeTerm = temp
        this.tempExcludeTerm = null
      }
    },
    removeHashtagFilter: function (val) {
      let temp = this.hashtag.slice()
      temp = temp.filter(v => v !== val)
      this.hashtag = temp
    },
    addHashtagFilter: function () {
      if (this.tempHashtag && !this.hashtag.includes(this.tempHashtag)) {
        let temp = [].slice.call(this.hashtag)
        temp.push(this.tempHashtag)
        this.hashtag = temp
        this.tempHashtag = null
      }
    },
    removeEmojiFilter: function (val) {
      let temp = this.emoji.slice()
      temp = temp.filter(v => v !== val)
      this.emoji = temp
    },
    addEmojiFilter: function () {
      if (this.tempEmoji && !this.emoji.includes(this.tempEmoji)) {
        let temp = [].slice.call(this.emoji)
        temp.push(this.tempEmoji)
        this.emoji = temp
        this.tempEmoji = null
      }
    },
    addEmojiFilterFromEmojiKeyboard: function (val) {
      if (val.native && !this.emoji.includes(val.native)) {
        let temp = [].slice.call(this.emoji)
        temp.push(val.native)
        this.emoji = temp
      }
    },
    removeDomainFilter: function (val) {
      let temp = this.domain.slice()
      temp = temp.filter(v => v !== val)
      this.domain = temp
    },
    addDomainFilter: function () {
      if (this.tempDomain && !this.domain.includes(this.tempDomain)) {
        let temp = [].slice.call(this.domain)
        temp.push(this.tempDomain)
        this.domain = temp
        this.tempDomain = null
      }
    },
    getData: function () {
      let i = 0
      let actions = []
      if (this.getFilters.countryId.length > 0) {
        actions.push(this.$store.dispatch('getCountriesByIds', { projectUuid: this.projectUuid, query: this.getCustomQuery({ countryId: this.getFilters.countryId }) }))
      }
      if (this.getFilters.stateId.length > 0) {
        actions.push(this.$store.dispatch('getStatesByIds', { projectUuid: this.projectUuid, query: this.getCustomQuery({ stateId: this.getFilters.stateId }) }))
      }
      if (this.getFilters.cityId.length > 0) {
        actions.push(this.$store.dispatch('getCitiesByIds', { projectUuid: this.projectUuid, query: this.getCustomQuery({ cityId: this.getFilters.cityId }) }))
      }
      if (this.getFilters.languageId.length > 0) {
        actions.push(this.$store.dispatch('getLanguagesByIds', { projectUuid: this.projectUuid, query: this.getCustomQuery({ languageId: this.getFilters.languageId }) }))
      }
      if (actions.length > 0) {
        axios.all(actions).then(axios.spread((...responses) => {
          for (i = 0; i < responses.length; i++) {
            if (responses[i].request.responseURL.includes('countries-by-ids') && responses[i].data.status === 'SUCCESS') {
              this.$store.commit('setSelectedCountries', responses[i].data.payload)
            }
            if (responses[i].request.responseURL.includes('states-by-ids') && responses[i].data.status === 'SUCCESS') {
              this.$store.commit('setSelectedStates', responses[i].data.payload)
            }
            if (responses[i].request.responseURL.includes('cities-by-ids') && responses[i].data.status === 'SUCCESS') {
              this.$store.commit('setSelectedCities', responses[i].data.payload)
            }
            if (responses[i].request.responseURL.includes('languages-by-ids') && responses[i].data.status === 'SUCCESS') {
              this.$store.commit('setSelectedLanguages', responses[i].data.payload)
            }
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
    }
  },
  created: function () {
    if (this.isLoggedIn === true && this.currentUser && this.currentUser.projects && Object.keys(this.currentUser.projects).length !== 0) {
      this.setAllFilters(this.$route.query)
    } else {
      this.$store.dispatch('auth/logout', { ...this.$data })
      this.$router.push({ path: '/login', query: this.$route.query })
    }
  },
  watch: {
    isLoggedIn: function (newVal, oldVal) {
      if (Boolean(newVal) === true) {
        if (this.currentUser === null || this.currentUser.projects === null || Object.keys(this.currentUser.projects).length === 0) {
          this.$store.dispatch('auth/logout', { ...this.$data })
          this.$router.push({ path: '/login', query: this.$route.query })
          this.notify({message: 'You have failed to log in. Make sure you have access to a project.', show: true})
        }
        if (this.currentUser && this.currentUser.projects && Object.keys(this.currentUser.projects).length !== 0) {
          this.setAllFilters(this.$route.query)
          this.notify({message: 'You have been logged in.', show: true})
        }
      }
    },
    '$route.query': {
      deep: true,
      handler (newVal, oldVal) {
        if (newVal && oldVal && !underscore.isEqual(newVal, oldVal) && this.isLoggedIn === true) {
          if (newVal.projectUuid !== oldVal.projectUuid) {
            this.resetAllFilters()
            this.getData()
          } else {
            this.setAllFilters(this.$route.query)
            this.getData()
          }
        }
      }
    },
    searchCountries: function (val) {
      if (val && val.length > 1) {
        this.countriesLoading = true
        var payload = {projectUuid: this.projectUuid, searchValue: val}
        axios.all([
          this.$store.dispatch('getCountriesBySearchValue', payload)
        ]).then(axios.spread((countriesResponse) => {
          if (countriesResponse.data.status === 'SUCCESS') {
            this.$store.commit('setCountries', countriesResponse.data.payload)
            this.countriesLoading = false
          } else {
            this.countriesLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.countriesLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      } else {
        this.$store.commit('setCountries', [])
      }
    },
    searchStates: function (val) {
      if (val && val.length > 1) {
        this.statesLoading = true
        var payload = {projectUuid: this.projectUuid, searchValue: val}
        axios.all([
          this.$store.dispatch('getStatesBySearchValue', payload)
        ]).then(axios.spread((statesResponse) => {
          if (statesResponse.data.status === 'SUCCESS') {
            this.$store.commit('setStates', statesResponse.data.payload)
            this.statesLoading = false
          } else {
            this.statesLoading = true
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.statesLoading = true
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      } else {
        this.$store.commit('setStates', [])
      }
    },
    searchCities: function (val) {
      if (val && val.length > 1) {
        this.citiesLoading = true
        var payload = {projectUuid: this.projectUuid, searchValue: val}
        axios.all([
          this.$store.dispatch('getCitiesBySearchValue', payload)
        ]).then(axios.spread((citiesResponse) => {
          if (citiesResponse.data.status === 'SUCCESS') {
            this.citiesLoading = false
            this.$store.commit('setCities', citiesResponse.data.payload)
          } else {
            this.citiesLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.citiesLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      } else {
        this.$store.commit('setCities', [])
      }
    },
    searchLanguages: function (val) {
      if (val && val.length > 1) {
        this.languagesLoading = true
        var payload = {projectUuid: this.projectUuid, searchValue: val}
        axios.all([
          this.$store.dispatch('getLanguagesBySearchValue', payload)
        ]).then(axios.spread((languagesResponse) => {
          if (languagesResponse.data.status === 'SUCCESS') {
            this.$store.commit('setLanguages', languagesResponse.data.payload)
            this.languagesLoading = false
          } else {
            this.languagesLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.languagesLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      } else {
        this.$store.commit('setLanguages', [])
      }
    }
  },
  components: {Notifier, DateRange, Picker}
}
</script>



// WEBPACK FOOTER //
// src/App.vue